import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

import {CARD_HEIGHT} from '../config';

export const styles = StyleSheet.create({
  base: {
    minHeight: CARD_HEIGHT,
    minWidth: 250,
  },
  cardHeaderText: {
    marginBottom: 12,
  },
  value: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  delta: {
    marginRight: 8,
  },
  listItem: {
    paddingVertical: 0,
    marginBottom: 10,
  },
  listItemLast: {
    marginBottom: 0,
  },
  divider: {
    height: 1,
    backgroundColor: cloudLight,
    marginBottom: 10,
  },
});
